import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslations } from '../context/TranslationContext';
import { translateArticlePath } from '../services/articles';

const LANGS: Array<{ code: 'ro' | 'hu' | 'en'; label: string }> = [
  { code: 'ro', label: 'RO' },
  { code: 'hu', label: 'HU' },
  { code: 'en', label: 'EN' },
];

export const InlineLanguageSwitch: React.FC = () => {
  const { lang } = useTranslations();
  const navigate = useNavigate();
  const location = useLocation();

  const navigateToLanguage = (newLang: 'hu' | 'ro' | 'en') => {
    const currentPath = location.pathname;

    // On an article page, follow the article's own translation link — slugs
    // differ per language, so swapping the prefix alone yields a dead URL.
    const translated = translateArticlePath(currentPath, newLang);

    let newPath: string;
    if (translated) {
      newPath = translated;
    } else if (currentPath.match(/\/(hu|ro|en)/)) {
      newPath = currentPath.replace(/\/(hu|ro|en)/, `/${newLang}`);
    } else {
      newPath = `/${newLang}${currentPath}` || `/${newLang}`;
    }

    // Client-side navigation: App derives the language from the router, so no
    // reload is needed and the prerendered HTML never flashes.
    navigate(newPath + location.hash);
  };

  return (
    <div className="flex items-center gap-3">
      {LANGS.map((l) => (
        <button
          key={l.code}
          onClick={() => navigateToLanguage(l.code)}
          className={`text-[11px] tracking-[0.2em] uppercase transition-colors ${
            lang === l.code ? 'text-ink' : 'text-mute hover:text-ink'
          }`}
          aria-label={`Switch to ${l.label}`}
          aria-current={lang === l.code ? 'true' : undefined}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
};

// Keep backwards compatibility export name
export const LanguageDropdown = InlineLanguageSwitch;
